import AppSearchPanel from "./AppSearchPanel";

export default AppSearchPanel;
